// extracted by mini-css-extract-plugin
module.exports = {"root":"sign-in_root__2X4oy","title":"sign-in_title__3cF_t","form":"sign-in_form__3lphF","signUp":"sign-in_signUp__2XVT-","forgotPassword":"sign-in_forgotPassword__3qIjQ"};